import { render, staticRenderFns } from "./SM-MT-Category-Selectbox.vue?vue&type=template&id=07d3d653"
import script from "./SM-MT-Category-Selectbox.vue?vue&type=script&lang=js"
export * from "./SM-MT-Category-Selectbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports